import { render } from "./HeaderWhite.vue?vue&type=template&id=5cd56c32&scoped=true"
import script from "./HeaderWhite.vue?vue&type=script&lang=js"
export * from "./HeaderWhite.vue?vue&type=script&lang=js"

import "./HeaderWhite.vue?vue&type=style&index=0&id=5cd56c32&scoped=true&lang=css"

import exportComponent from "/Users/tamotsu/Documents/たもつ製作所/jibi/jibi-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd56c32"]])

export default __exports__